import { combineReducers } from 'redux-merge-immutable-reducers';

import customer from './customer/customer';
import hotels from './hotels/hotels';
import avail from './avail/avail';
import availServices from './avail/availServices';
import availCalendar from './avail/availCalendar';
import availCache from '@synergycms_core/store/avail/availCache';
import notifications from '@synergycms_core/store/notifications/notifications';
import app from '@synergycms_core/store/app/app';
import actions from './actions';
import { List, fromJS, Map } from 'immutable';
import { handleActions } from 'redux-actions';
import system from '@synergycms_core/store/customer/system';
//REDUCERS

const countries = handleActions(
  {
    [actions.countries.get.toString()]: (store, action) => {
      return fromJS(action.payload);
    }
  },
  List()
);


const group = handleActions(
  {
    [actions.group.get.toString()]: (store, action) => {
      return fromJS(action.payload);
    }
  },
  List()
);

const groupInfo = handleActions(
  {
    [actions.groupInfo.getAsync.toString()]: (store, action) => {
      return fromJS(action.payload);
    }
  },
  Map()
);

const availQuery = handleActions(
  {
    [actions.availQuery.setMultiAvailKeys.toString()]: (store, action) => {
       return store.set("multi", action.payload);
    },
    [actions.availQuery.setMonoAvailKeys.toString()]: (store, action) => {
      return store.set("mono", action.payload);
   }
  },
  Map({
    multi : Map({
      base :"base_string_query_params",
      params:"query_params",
      string_params :"string_query_params",
      params_service :"service_query_params",
      string_service :"string_service_query_params",
      params_calendar :"calendar_query_params",
      string_calendar :"string_calendar_query_params",
      base_params_calendar :"calendar_query_params",
      base_string_calendar :"string_calendar_query_params",
    }),
    mono: Map({
      base :"base_string_query_params",
      params:"query_params",
      string_params :"string_query_params",
      params_service :"service_query_params",
      string_service :"string_service_query_params",
      params_calendar :"calendar_query_params",
      string_calendar :"string_calendar_query_params",
      base_params_calendar :"calendar_query_params",
      base_string_calendar :"string_calendar_query_params",
    })
  })
);


export default combineReducers({ customer, app, hotels, avail, availServices, availCalendar, availCache, countries, group, groupInfo, system, notifications,availQuery });
